import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import logo from "../../assets/logo.webp";
import { FaPhone, FaWhatsapp } from "react-icons/fa";
import { MdPerson } from "react-icons/md";

const Navbar = () => {
  const contact = {
    phone: "01212220604",
    whatsapp: "201212220604",
  };

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const closeAllMenus = () => {
    setServicesOpen(false);
    setMobileMenuOpen(false);
  };

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        closeAllMenus();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header>
      {/* Topbar
      <div className="topbar">
        <div className="quick-links">
          <a href="#">
            <MdPerson /> BOOK A CALL WITH AN EXPERT
          </a>
          <a href={`tel:${contact.phone}`}>
            <FaPhone className="contact-icon" /> CALL NOW: {contact.phone}
          </a>
          <a href={`https://wa.me/${contact.whatsapp}`} className="whatsapp">
            <FaWhatsapp /> WhatsApp
          </a>
        </div>
      </div> */}
      {/* Navbar */}
      <nav className="navbar">
        <div className="logo center-logo">
          <a href="/">
            <img src={logo} alt="BinRashid Logo" />
          </a>
        </div>

        <button
          className="burger-icon"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul
          className={`nav-links ${mobileMenuOpen ? "open" : ""}`}
          ref={dropdownRef}
        >
          <li>
            <a href="/" onClick={closeAllMenus}>
              HOME
            </a>
          </li>

          {/* Services Dropdown */}
          <li className="dropdown">
            <button
              className="dropdown-toggle"
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              SERVICES <span className="arrow">▼</span>
            </button>

            {servicesOpen && (
              <div className="dropdown-content">
                <a href="/business-solutions" onClick={closeAllMenus}>
                  Business Solutions
                </a>
                <a href="/consulting" onClick={closeAllMenus}>
                  Consulting
                </a>
                <a href="/construction-interior" onClick={closeAllMenus}>
                  Construction &amp; Interior Design
                </a>
              </div>
            )}
          </li>
          {/* 
          <li>
            <a href="#" onClick={closeAllMenus}>
              CAREERS
            </a>
          </li> */}
          <li>
            <a href="/contact-us" onClick={closeAllMenus}>
              CONTACT US
            </a>
          </li>
          {/* <li>
            <a href="#" onClick={closeAllMenus}>
              BLOG
            </a>
          </li> */}
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
